<template>
  <div class="img-preview" @click.stop="">
    <el-image
      :src="src"
      :preview-src-list="srcList"
      :alt="alt"
      :fit="fit">
    </el-image>
  </div>
</template>

<script>
export default {
  props: {
    src: {
      type: String,
      required: true,
    },
    srcList: {
      type: Array,
      default: () => [],
    },
    alt: {
      type: String,
      default: '',
    },
    fit: {
      type: String,
      default: '',
    },
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-image, .el-image__inner {
  width: 100%;
  height: 100%;
}

.img-preview {
  width: 100%;
  height: 100%;
  cursor: pointer;
}
</style>>
